<template>
    <div>
        <div>
            <vue-headful :title="$t('title_dashboard')" description="title" />
            <OnBoardingContent />
        </div>
        <v-container fluid>
            <v-row class="mx-2">
                <TopBar />
                <!-- <AssignedBook /> -->
                <v-row>
                    <v-col cols="12" md="6" class="pa-0 pa-md-3">
                        <v-col cols="12" class="w-100 mt-2 home-carousel">
                            <CarouselBooks />
                        </v-col>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-0 pa-sm-3">
                        <v-col cols="12" class="w-100 mt-2 fill-height custom-card">
                            <EventsSection />
                        </v-col>
                    </v-col>
                </v-row>
            </v-row>
            <v-row class="ma-2 d-none d-sm-flex">
                <v-col v-if="!hidePersonalBooks" cols="12" md="6" class="pa-0 pa-md-3 pl-md-0">
                    <v-col cols="12" class="pa-0 h-100 mt-0">
                        <CarouselMostPopular />
                    </v-col>
                </v-col>
                <v-col cols="12" :md="hidePersonalBooks ? 12 : 6" class="pa-0 pa-md-3 pr-md-0 mt-3 mt-md-0">
                    <v-col cols="12" class="w-100 fill-height custom-card">
                        <HeadChallengeCard
                            @openDialog="openDialog"
                        />
                    </v-col>
                </v-col>
            </v-row>
            <PrizeChallenge
                :dialogVisible="dialogVisible"
                @closeDialog="closeDialog"
                @updateDialog="updateDialog"
            />
            <SchoolPopup
                v-if="shouldDisplaySchoolPopup"
                :visible="schoolPopupVisible"
                :image-src="schoolPopupImage"
                :link="schoolPopupLink"
                @close="closeSchoolPopup"
                @link-click="onSchoolPopupLinkClick"
            />
        </v-container>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import AssignedBook from '@/components/home/AssignedBook.vue'
import CentralSection from '@/components/home/CentralSection.vue'
import Ranking from '@/components/home/Ranking.vue'
import SuperRecommended from '@/components/home/SuperRecommended.vue'
import TopBar from '@/components/home/TopBar.vue'
import OnBoardingContent from '@/components/onBoarding/OnBoardingContent.vue'
import CarouselBooks from '@/components/home/CarouselBooks.vue'
import EventsSection from '@/components/home/EventsSection.vue'
import HeadChallengeCard from '@/components/challenge/HeadChallengeCard.vue'
import PrizeChallenge from '@/components/challenge/PrizeChallenge.vue'
import CarouselMostPopular from '@/components/home/CarouselMostPopular.vue'
import SchoolPopup from '@/components/home/SchoolPopup.vue'

import AnalyticEventsMixin from "@/mixins/analyticEvents"
import timeTrackerMixin from '@/mixins/timeTrackerMixin'
import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
    data() {
        return {
            dialogVisible: false,
            schoolPopupVisible: false,
            schoolPopupDismissed: false,
        }
    },
    mixins: [AnalyticEventsMixin, timeTrackerMixin],
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            user: (state) => state.userData.user,
            dashboard: (state) => state.dashboard,
        }),
        userSchoolId() {
            const schoolId = this.user?.school?.id
            return schoolId ? String(schoolId) : null
        },
        schoolPopupTargetSchools() {
            const arlingtonIds = this.arlingtonSchoolIds
            const sanFelipeIds = this.sanFelipeSchoolIds
            return [...arlingtonIds, ...sanFelipeIds]
        },
        arlingtonSchoolIds() {
            const envValue = process.env.VUE_APP_SCHOOL_POPUP_ARLINGTON_IDS || ''
            return envValue
                .split(',')
                .map((item) => item.trim())
                .filter((item) => item.length > 0)
        },
        sanFelipeSchoolIds() {
            const envValue = process.env.VUE_APP_SCHOOL_POPUP_SAN_FELIPE_IDS || ''
            return envValue
                .split(',')
                .map((item) => item.trim())
                .filter((item) => item.length > 0)
        },
        schoolPopupStartDate() {
            return this.parseDate(process.env.VUE_APP_SCHOOL_POPUP_START)
        },
        schoolPopupEndDate() {
            const endValue = process.env.VUE_APP_SCHOOL_POPUP_END
            const explicitEnd = this.parseDate(endValue)
            if (explicitEnd) return explicitEnd
            if (!this.schoolPopupStartDate) return null
            const derivedEnd = new Date(this.schoolPopupStartDate.getTime())
            derivedEnd.setDate(derivedEnd.getDate() + 7)
            return derivedEnd
        },
        isSchoolPopupInDateRange() {
            const now = new Date()
            if (this.schoolPopupStartDate && now < this.schoolPopupStartDate) return false
            if (this.schoolPopupEndDate && now > this.schoolPopupEndDate) return false
            return true
        },
        isOnboardingActive() {
            return (
                this.dashboard.showInitialGreeting ||
                this.dashboard.showAvatarModal ||
                this.dashboard.showCategoriesModal ||
                this.dashboard.mount_diagnostic ||
                this.dashboard.showInitialPoll ||
                this.dashboard.showFinishPreferencesModal ||
                this.dashboard.showFinishSurveyModal ||
                this.dashboard.showDiagnosticTutorialModal ||
                this.dashboard.showFinishOnboardingModal
            )
        },
        shouldDisplaySchoolPopup() {
            if (this.schoolPopupDismissed || !this.userSchoolId || !this.schoolPopupTargetSchools.length || !this.isSchoolPopupInDateRange || this.isOnboardingActive) return false
            return this.schoolPopupTargetSchools.includes(this.userSchoolId)
        },
        schoolPopupImage() {
            return process.env.VUE_APP_SCHOOL_POPUP_IMAGE || ''
        },
        schoolPopupLink() {
            if (!this.userSchoolId) return ''
            if (this.arlingtonSchoolIds.includes(this.userSchoolId)) {
                return process.env.VUE_APP_SCHOOL_POPUP_ARLINGTON_LINK || ''
            }
            if (this.sanFelipeSchoolIds.includes(this.userSchoolId)) {
                return process.env.VUE_APP_SCHOOL_POPUP_SAN_FELIPE_LINK || ''
            }
            return ''
        },
        hidePersonalBooks() {
            return Boolean(this.user?.school?.hide_personal_books)
        },
    },
    components: {
        AssignedBook,
        CentralSection,
        Ranking,
        SuperRecommended,
        TopBar,
        OnBoardingContent,
        CarouselBooks,
        EventsSection,
        HeadChallengeCard,
        PrizeChallenge,
        CarouselMostPopular,
        SchoolPopup,
    },
    mounted() {
        this.createAnalyticEvent(AnalyticEventTypes.GoToHome)
    },
    methods: {
        parseDate(dateString) {
            if (!dateString) return null
            const parts = dateString.split('/')
            if (parts.length === 3) {
                const day = parseInt(parts[0], 10)
                const month = parseInt(parts[1], 10) - 1
                const year = parseInt(parts[2], 10)
                const date = new Date(year, month, day)
                if (!Number.isNaN(date.getTime())) {
                    return date
                }
            }
            const date = new Date(dateString)
            return Number.isNaN(date.getTime()) ? null : date
        },
        openDialog() {
            this.dialogVisible = true
        },
        closeDialog() {
            this.dialogVisible = false
        },
        updateDialog(value) {
            this.dialogVisible = value
        },
        closeSchoolPopup() {
            this.schoolPopupVisible = false
            this.schoolPopupDismissed = true
        },
        onSchoolPopupLinkClick() {
            this.closeSchoolPopup()
        },
    },
    watch: {
        shouldDisplaySchoolPopup: {
            immediate: true,
            handler(value) {
                this.schoolPopupVisible = value && !this.schoolPopupDismissed
            },
        },
    },
}
</script>

<style lang="scss">
.home-carousel{
    border-radius: 1rem;
    height: 100%;
    @media screen and (min-width: 960px) {
        .header-section * {
            color: white;
        }
        background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
    }
    @media screen and (max-width: 960px) {
        margin-bottom: 15px;
    }
    @media screen and (max-width: 600px) {
        margin-bottom: 5px;
    }
}
</style>
